import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import { useNiveles } from "../../../../context/SuperAdmin/OASContexts/NivelesContext";

const HeaderNiveles = () => {
  const {
    toggleCreateModal,
    selectedNiveles,
    toggleDeleteModal,
    searchText,
    setSearchText,
  } = useNiveles();

  return (
    <Grid container spacing={4} display={"flex"} alignItems={"center"}>
      {/* Formulario de búsqueda */}
      <Grid item xs={6} md={6}>
        {/* Search bar */}
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ej: 3er grado"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid
        item
        xs={6}
        md={6}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"flex-end"}
        gap={2}
      >
        <Button
          variant="outlined"
          onClick={() => toggleDeleteModal(true)}
          disabled={!selectedNiveles.length}
          sx={{
            borderRadius: 14,
            border: "1px solid #336B87",
            color: "#336B87",
            "&:hover": {
              backgroundColor: "#336B87",
              color: "#EEF3F6",
            },
          }}
        >
          Eliminar
        </Button>
        <Button
          variant="contained"
          onClick={() => toggleCreateModal(true)}
          sx={{ background: "#336B87" }}
        >
          Crear nivel
        </Button>
      </Grid>
    </Grid>
  );
};

export default HeaderNiveles;
